import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HelpCircle, X } from 'lucide-react';

function HelpModal({ isOpen, onClose }) {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="modal" onClick={onClose} style={{ zIndex: 4000 }}>
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            className="modal-content help-modal"
            onClick={e => e.stopPropagation()}
            style={{ maxWidth: '800px' }}
          >
            <div className="modal-header">
              <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                <HelpCircle size={28} color="var(--google-blue)" />
                <h3 style={{ margin: 0 }}>Help & Features Guide</h3>
              </div>
              <button className="menu-toggle" onClick={onClose}><X /></button>
            </div>

            <div className="help-content">
              <section>
                <h4>📊 Overview</h4>
                <p>Farm Admin is a comprehensive management system for poultry broiler farms, designed to track payroll, sales, harvest performance, and mortality data.</p>
              </section>

              <section>
                <h4>🚀 Core Features</h4>
                <div className="feature-grid">
                  <div className="feature-item">
                    <strong>Payroll & Employees</strong>
                    <p>Track wages, advances, and balances with detailed audit trails for every change.</p>
                  </div>
                  <div className="feature-item">
                    <strong>Sales & Auditing</strong>
                    <p>Manage buyer records, tally sheets, and link harvest agents to specific sales.</p>
                  </div>
                  <div className="feature-item">
                    <strong>Mortality & Feeds</strong>
                    <p>Log daily deaths and feed consumption with multi-row bulk entry and interactive analytics.</p>
                  </div>
                  <div className="feature-item">
                    <strong>Intelligent Search</strong>
                    <p>Use prefixes like <code>sale</code>, <code>harvest</code>, <code>death</code> or <code>employee</code> to narrow a search to one module.</p>
                  </div>
                </div>
              </section>

              <section>
                <h4>⌨️ Shortcuts & Tips</h4>
                <ul>
                  <li><kbd>Ctrl/Cmd + K</kbd> - Open Global Search</li>
                  <li><kbd>↑</kbd> <kbd>↓</kbd> then <kbd>Enter</kbd> - Move through and open search results</li>
                  <li><kbd>ESC</kbd> - Close any modal or overlay</li>
                  <li>Click on a record row or card to view/edit details.</li>
                  <li>Switch between <strong>Table</strong> and <strong>Card</strong> views using the toggle in the list controls.</li>
                </ul>
              </section>

              <section>
                <h4>🛡️ Security</h4>
                <p>Whitelisted Google accounts have protected admin status. Standard admin login can be disabled for maximum security.</p>
              </section>
            </div>

            <div className="form-actions">
              <button className="submit-btn" onClick={onClose}>Got it, thanks!</button>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}

export default HelpModal;
